import axios from 'axios';

let isRefreshing = false;
let block = Promise.resolve(window.localStorage.getItem('token'));

export const Axios = axios.create({
    baseURL: '/api',
    timeout: 60000,
});

export function setToken(token) {
    window.localStorage.setItem('token', token);
    block = Promise.resolve(token);
}

function refreshToken(bearer) {
    return Axios.post('refresh', {}, {
        headers: {
            Authorization: bearer,
        },
    });
}

Axios.interceptors.request.use(config => {
    if (config.url === 'refresh') {
        return config;
    }

    if (config.url === '/broadcasting/auth' ) {
        config.baseURL = '';
    }

    return block.then(token => {
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    });
});

Axios.interceptors.response.use(response => {
    const { config, data: { token } } = response;

    if (config.url === '/api/verify') {
        setToken(token);
    }

    return response;
}, error => {
    if (axios.isCancel(error)) {
        return Promise.reject(error);
    }

    if (error.request && error.message === 'Network Error') {
        return Promise.reject({
            response: {
                data: {
                    message: '網路發生異常或超時，請檢查網路狀態',
                    errors: {},
                }
            }
        })
    }

    const { config, response: { status, data } } = error;
    const originalRequest = config;

    if (status === 401 && data.code === 'TOKEN_EXPIRED') {
        if ( ! isRefreshing) {
            isRefreshing = true;

            block = refreshToken(config.headers.Authorization).then(({ data: { token } }) => {
                window.localStorage.setItem('token', token);
                isRefreshing = false;

                return token;
            });
        }

        return block.then(token => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            originalRequest.baseURL = '';

            return axios(originalRequest);
        });
    }

    return Promise.reject(error);
});

export default {
    install(Vue) {
        Object.defineProperty(Vue.prototype, '$axios', { value: Axios })
    }
}
